import { useTailwindBreakpoints } from "components/hooks/use-tailwind-breakpoints"

import { Box } from "components/shared/box"
import { ClippedBox } from "components/shared/clipped-box/clipped-box"

import clippedCorners from "utils/clipped-corners"
import { snakeCaseToReadableString } from "utils/snake-case-to-readable-string"

import styles from "./main-info.module.scss"
import type { MainStatData } from "./main-stat"
import { MainStat } from "./main-stat"

type MainInfoProps = {
  mainInfoData: MainStatData[]
  archetype?: string
}

// TODO add border clip
export function MainInfo({ mainInfoData, archetype }: MainInfoProps) {
  const { isMobile } = useTailwindBreakpoints()
  const corners = isMobile ? clippedCorners.rt : clippedCorners.lb_rt

  const justifyClassName =
    mainInfoData.length > 3 ? "gap-2.5 lg:gap-1.5 justify-around lg:justify-between" : "justify-center gap-12"

  return (
    <ClippedBox
      corners={corners}
      clipK="2.25rem"
      className={`w-full rounded-md p-1 mb-3 lg:mb-8 relative overflow-hidden ${styles["main-info-gradient"]}`}
    >
      <ClippedBox corners={corners} clipK="2.25rem" full className="bg-[#40379E] relative rounded-md p-1">
        <ClippedBox corners={corners} clipK="2rem" className={`rounded-md ${styles["main-info-block-gradient"]}`}>
          <ClippedBox corners={corners} clipK="2rem" className={`rounded-md ${styles["main-info-gradient"]}`}>
            {archetype && (
              <ClippedBox
                className={[
                  "absolute bottom-0 px-6 lg:px-10 bg-[#4f4acc] text-[0.8rem] lg:text-base z-1 left-0 lg:left-1.5 rounded-bl-md font-semibold",
                ].join(" ")}
                corners={corners}
                clipK={`${isMobile ? "0.9rem" : "2rem"}`}
              >
                {snakeCaseToReadableString(archetype)}
              </ClippedBox>
            )}
            <Box row className={` p-3 pb-5 lg:pb-7 lg:px-6 ${justifyClassName}`}>
              {mainInfoData.map(({ label, value, icon }) => (
                <MainStat key={label} showRightBorder={false} label={label} value={value} icon={icon} />
              ))}
            </Box>
          </ClippedBox>
        </ClippedBox>
      </ClippedBox>
    </ClippedBox>
  )
}
